function HexLogomark({ size = 420, className = '' }) {
  const stroke = 1.2;
  return (
    <div
      className={`hex-logomark ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {/* Ambient glow orbs */}
      <div className="hex-logomark__orb hex-logomark__orb--a" />
      <div className="hex-logomark__orb hex-logomark__orb--b" />

      {/* Rotating outer ring (slow) */}
      <svg
        viewBox="0 0 420 420"
        className="hex-logomark__ring slow-spin"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
      >
        <defs>
          <linearGradient id="hexGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFCB47" stopOpacity="0.95" />
            <stop offset="50%" stopColor="#FFD56B" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#FFA629" stopOpacity="0.95" />
          </linearGradient>
          <linearGradient id="hexGradientFaint" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFCB47" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#FFA629" stopOpacity="0.15" />
          </linearGradient>
        </defs>
        <polygon
          points="210,18 386,111 386,309 210,402 34,309 34,111"
          fill="none"
          stroke="url(#hexGradient)"
          strokeWidth={stroke * 2}
          strokeLinejoin="round"
        />
      </svg>

      {/* Counter-rotating inner ring */}
      <svg
        viewBox="0 0 420 420"
        className="hex-logomark__ring-inner slow-spin-reverse"
        style={{ position: 'absolute', inset: 40, width: 'calc(100% - 80px)', height: 'calc(100% - 80px)' }}
      >
        <polygon
          points="170,14 310,90 310,250 170,326 30,250 30,90"
          transform="translate(0,0)"
          fill="none"
          stroke="url(#hexGradientFaint)"
          strokeWidth={stroke}
          strokeLinejoin="round"
        />
      </svg>

      {/* Static concentric geometry */}
      <svg
        viewBox="0 0 420 420"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
      >
        <defs>
          <linearGradient id="sGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFE7A8" />
            <stop offset="50%" stopColor="#FFCB47" />
            <stop offset="100%" stopColor="#E0A820" />
          </linearGradient>
          <filter id="sGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <path id="labelPath" d="M 60 210 A 150 150 0 0 0 360 210" fill="none" />
        </defs>

        {/* Inner hex frame */}
        <polygon
          points="210,78 330,145 330,279 210,346 90,279 90,145"
          fill="rgba(255, 203, 71, 0.03)"
          stroke="rgba(255, 203, 71, 0.25)"
          strokeWidth="1"
        />

        {/* Corner tick marks */}
        {[
          [210, 18], [210, 402], [34, 111], [34, 309], [386, 111], [386, 309],
        ].map(([cx, cy], i) => (
          <circle key={i} cx={cx} cy={cy} r="3" fill="#FFCB47" />
        ))}

        {/* Monogram "S" */}
        <text
          x="210"
          y="245"
          textAnchor="middle"
          fontFamily="Inter, sans-serif"
          fontSize="150"
          fontWeight="900"
          fill="url(#sGradient)"
          filter="url(#sGlow)"
          style={{ letterSpacing: '-0.04em' }}
        >
          S
        </text>

        {/* Bottom label arc */}
        <text
          fontFamily="JetBrains Mono, monospace"
          fontSize="11"
          fontWeight="500"
          letterSpacing="4"
          fill="rgba(255, 203, 71, 0.65)"
        >
          <textPath href="#labelPath" startOffset="50%" textAnchor="middle">
            IMMUTABLE · ON-CHAIN · BSC · USDT
          </textPath>
        </text>
      </svg>
    </div>
  );
}

export default HexLogomark;
